import { CoreRichEditor } from "@/content-hub/theme/primitives/rich-text";

import { hasDisplayDescriptionContent } from "./has-display-description-content";

/** Video Details only — matches min toolbar: B/I/U/S + lists (no link/heading). */
const VIDEO_DETAILS_TOOLBAR_CONFIG = {
  toolbar: {
    isFloating: false,
    items: [
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "|",
      "bulletedList",
      "numberedList",
    ],
  },
};

const editorShellClassName = [
  "video-details-description-editor",
  "rounded-lg",
  "[&_.document-editor__toolbar]:z-[1]",
  "[&_.ck-content_p]:mb-2 [&_.ck-content_p]:text-sm [&_.ck-content_p]:leading-normal",
  "[&_.ck-content_ol]:mb-2 [&_.ck-content_ol]:!pl-[1.35rem]",
  "[&_.ck-content_ul]:mb-2 [&_.ck-content_ul]:!pl-[1.35rem]",
  "[&_.ck-content_li]:mb-1 [&_.ck-content_li]:text-sm [&_.ck-content_li]:!leading-normal",
].join(" ");

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/** Plain-text descriptions (e.g. from recordings API) are wrapped for CKEditor. */
export function toVideoDetailsDescriptionHtml(value: string): string {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) return "";
  if (trimmed.startsWith("<")) return value;
  return `<p>${escapeHtml(trimmed)}</p>`;
}

type VideoDetailsDescriptionEditorProps = {
  value: string;
  onChange: (html: string) => void;
  /** Flush pending debounced commits when focus leaves the editor. */
  onBlur?: () => void;
  /** Remount when the edited block/row changes (e.g. Craft node id). */
  editorKey: string;
};

/**
 * Rich-text description for Video / Video Grid Details (preference panel).
 */
export function VideoDetailsDescriptionEditor({
  value,
  onChange,
  onBlur,
  editorKey,
}: VideoDetailsDescriptionEditorProps) {
  return (
    <div className={editorShellClassName} onBlur={onBlur}>
      <CoreRichEditor
        key={editorKey}
        pinToolbar
        text={toVideoDetailsDescriptionHtml(value)}
        onChange={(html) =>
          onChange(hasDisplayDescriptionContent(html) ? html : "")
        }
        config={VIDEO_DETAILS_TOOLBAR_CONFIG}
      />
    </div>
  );
}
